// extracted by mini-css-extract-plugin
module.exports = {"solar-energy-solutions-tabs":"SolarEnergySolutions_solar-energy-solutions-tabs__RS_2I","solar-energy-solutions":"SolarEnergySolutions_solar-energy-solutions__V4fxF"};